import { useState, useCallback } from "react";
import { sendBatchProspectsToFtp } from "@/api/sendBatchProspectsToFtp/sendBatchProspectsToFtpApi";
import { useNotification } from "@/context/NotificationContext";
import axios from "axios";

export const useSendBatchProspectsToFtp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { showNotification } = useNotification();

  const sendToFtp = useCallback(
    async (week: number, year: number) => {
      setLoading(true);
      setError(null);

      try {
        const response = await sendBatchProspectsToFtp({ week, year });

        // Success case
        const successMessage =
          response.message ||
          `File exported successfully for week ${week}, ${year}`;

        showNotification("Export Successful", successMessage, "success");

        return response;
      } catch (err: unknown) {
        let errorMessage = "Failed to send batch prospects to FTP";

        if (axios.isAxiosError(err)) {
          // Handle Axios errors
          if (err.response?.data?.error) {
            errorMessage = err.response.data.error;
          } else if (err.response?.status === 401) {
            errorMessage = "Unauthorized - Please log in again";
          } else if (err.response?.status === 400) {
            errorMessage = "Invalid request parameters";
          } else if (err.response?.status === 503) {
            errorMessage =
              "Service temporarily unavailable - Please try again later";
          } else if (err.message) {
            errorMessage = err.message;
          }
        } else if (err instanceof Error) {
          errorMessage = err.message;
        }

        console.error("Error sending to FTP:", errorMessage);
        setError(errorMessage);

        // Show error notification
        showNotification("Export Failed", errorMessage, "error");

        throw err;
      } finally {
        setLoading(false);
      }
    },
    [showNotification]
  );

  return {
    sendToFtp,
    loading,
    error,
  };
};
